export function pick(obj) {
    var keys = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        keys[_i - 1] = arguments[_i];
    }
    var result = {};
    for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        if (obj.hasOwnProperty(key)) {
            result[key] = obj[key];
        }
    }
    return result;
}
;
export default pick;

//# sourceMappingURL=pick.js.map



//////////////////
// WEBPACK FOOTER
// ./~/reassemble/lib/utils/pick.js
// module id = 6
// module chunks = 0